import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import Icon from '../Icon';
import _ from 'lodash';
import { delay, playSound, dbget, dbset } from '../../HOME/utils';
import { PRACTICE, COMPETE, HIT, MISS, CLEAR_LEVEL, RESET } from '../const';
import { OVER, TASKS_PER_LEVEL, LEVELS_COMPLETED_KEY, SAVED_GAME_KEY } from '../const';
import { setPracticeStep, setTimeLeft, setScore, setLevel, updateStats } from '../REDUX/actions';
import { setLevelsCompleted, setStartLevel, setIntroduced, pause } from '../REDUX/actions';
import { setLoadingGame, showIntro, setMode } from '../REDUX/actions';
import { requestResetStats, requestSurrender, showLeaderboards, goToPage, SHOW_LEADERS, OVER_RESTART } from '../../HOME/REDUX/actions';
import Instructions from '../COMPONENTS/Instructions';
import Scoreboard from '../COMPONENTS/Scoreboard';
import Intro from './Intro';
import * as f from '../logic';
import PracticeIcon from './PracticeIcon';
import CompeteIcon from './CompeteIcon';
import ResumeIcon from '../../HOME/SVG/PlayIcon';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import { SKILL_PAGE, YELLOW, GREEN } from '../../HOME/const';
import GameOverOptions from '../../HOME/COMPONENTS/GameOverOptions';

const colorsSets = [
  { light: '#cccd33', medium: '#b7b82d', dark: '#a3a428' },
  { light: '#fc355c', medium: '#e22f52', dark: '#c92a49' },
  { light: '#53aedb', medium: '#4a9cc5', dark: '#428baf' },
  { light: '#ff9934', medium: '#e5892e', dark: '#cc7a29' },
  { light: '#986699', medium: '#885b89', dark: '#79517a' },
];

const ROTATION_DURATION = 300;
const ROTAION_TRANSITION = `transform ${ROTATION_DURATION}ms`;

class Board extends Component {
  state = { bigShapes: [], smallShapes: [], miss: false };
  hideSolution = false;

  componentDidMount() {
    this.newSet();

    if (this.props.mode === PRACTICE) {
      this.practiceHits = 0;
    }
  }

  componentWillUnmount() {
    this.saveGame();
    this.resetTimer(0);
    this.props.requestResetStats(false);
    this.props.requestSurrender(false);
    this.props.pause(false);
    this.props.showIntro(false);
  }

  sampleShapes = count => {
    const shapes = _.sampleSize(['cone', 'cube', 'cylinder', 'octahedron', 'prism', 'pyramid', 'ring', 'sphere'], count);

    const colors = _.sampleSize(colorsSets, count);

    return _.map(shapes, (s, i) => {
      return { shape: s, colors: colors[i] };
    });
  };

  newSet = () => {
    if (this.props.loadingGame) {
      dbget(SAVED_GAME_KEY, game => {
        this.props.setTimeLeft(game.timeLeft);
        Promise.resolve().then(this.doNewSet);
      });
    } else {
      this.resetTimer();
      this.doNewSet();
    }
  };

  doNewSet = () => {
    const { mode } = this.props;

    const generateBigShapes = () => {
      const { practiceStep } = this.props;
      const { smallShapes } = this.state;
      const index = this.state.solutionIndex;
      const solutionShape = smallShapes[index];
      const shapes = _.shuffle(_.filter(smallShapes, (s, j) => j !== index));
      let match = -1;

      if (mode === PRACTICE) {
        if (practiceStep === 1 || (practiceStep > 2 && this.state.match)) {
          match = _.random();
        }
      } else if (this.state.match) {
        match = _.random();
      }

      const bigShapes = [
        match === 0 ? solutionShape : { shape: shapes[0].shape, colors: shapes[1].colors },
        match === 1 ? solutionShape : { shape: shapes[2].shape, colors: shapes[3].colors },
      ];

      const setTimer = () => {
        if (this.props.mode === PRACTICE || this.props.intro) {
          return;
        }

        if (this.props.loadingGame) {
          this.props.setLoadingGame(false);
        } else {
          this.props.setTimeLeft();
        }

        this.interval = setInterval(() => {
          if (this.props.paused) {
            return;
          }

          if (this.props.intro) {
            this.resetTimer();
            return;
          }

          const time = this.props.timeLeft - 1;

          this.props.setTimeLeft(time);

          if (time === 0) {
            this.handleMiss();
          }
        }, 100);
      };

      this.setState({ bigShapes }, () => setTimer());
    };

    this.setState({ transform: 'rotateY(90deg)' });

    delay(() => {
      const { practiceStep } = this.props;

      this.setState(
        {
          transform: 'rotateY(0deg)',
          solutionIndex: _.random(4),
          smallShapes: this.sampleShapes(5),
          match:
            (mode === PRACTICE && (practiceStep === 1 || (practiceStep > 2 && _.random(2) === 0))) || (mode === COMPETE && _.random(2) === 0),
        },
        generateBigShapes
      );
    }, ROTATION_DURATION);
  };

  saveGame = () => {
    if (this.state.gameOver) {
      return;
    }

    const { hits, misses, score, level, startLevel, timeLeft } = this.props;

    if (hits > 0 || misses > 0) {
      let time = Math.ceil(timeLeft / 10) * 10;
      time = time === 0 ? undefined : Math.max(Math.min(time, f.levelInfo(level).time), 32);

      dbset(SAVED_GAME_KEY, { hits, misses, score, level, startLevel, timeLeft: time });
    }
  };

  blink = count => {
    if (count-- === 0) {
      return;
    }

    this.hideSolution = !this.hideSolution;
    this.forceUpdate();

    delay(() => this.blink(count));
  };

  handleTouch = i => {
    this.touch = true;
    this.handleClick(i);
  };

  handleMouseDown = i => {
    if (!this.touch) {
      this.handleClick(i);
    }
  };

  handleClick = i => {
    if (this.state.gameOver) {
      return;
    }

    if (i !== this.state.solutionIndex) {
      this.handleMiss();
      return;
    }

    if (this.state.miss) {
      playSound(this.props, 'tap');
    } else {
      if (this.props.mode === PRACTICE) {
        playSound(this.props, 'coin2');

        ++this.practiceHits;
        this.forceUpdate();
      }
      const res = this.updateScore(HIT);

      if (res === CLEAR_LEVEL) {
        const { level } = this.props;

        if (level < 4) {
          dbset(LEVELS_COMPLETED_KEY, level);
          this.props.setLevelsCompleted(level);
          this.props.setLevel(level + 1);
        }

        Promise.resolve().then(() => {
          this.updateScore(CLEAR_LEVEL);
          this.props.setTimeLeft();
        });

        delay(() => {
          this.props.showIntro(true);
          playSound(this.props, 'draw');
        }, 300);
      }
    }

    this.setState({ miss: false });

    if (this.props.mode === PRACTICE) {
      const step = Math.min(3, this.props.practiceStep + 1);

      if (step !== this.props.practiceStep) {
        this.props.setPracticeStep(step);
      }
    }

    Promise.resolve().then(this.newSet);
  };

  handleMiss = () => {
    playSound(this.props, 'lost');

    if (!this.state.miss) {
      const res = this.updateScore(MISS);

      if (res === OVER) {
        playSound(this.props, 'won');
        this.setState({ gameOver: true });
      }
    }

    this.setState({ miss: true });

    this.blink(6);
    this.resetTimer(0);
  };

  updateScore = action => {
    let { mode, hits, misses, score, level, startLevel } = this.props;

    if (mode === PRACTICE) {
      return;
    }

    switch (action) {
      case HIT:
        ++hits;
        const maxGain = f.levelInfo(1).time;
        let gain = Math.min(maxGain, maxGain - f.levelInfo(level).time + this.props.timeLeft);
        playSound(this.props, gain > 80 ? 'coins' : gain > 50 ? 'coin2' : 'coin1');
        if (startLevel > 1 && level === startLevel && (level < 4 || hits <= TASKS_PER_LEVEL)) {
          gain *= startLevel;
        }
        this.setState({ gain, showGain: true }, () => delay(() => this.setState({ showGain: false }), 300));
        score += gain;
        break;
      case MISS:
        ++misses;
        break;
      case CLEAR_LEVEL:
        misses = 0;
        break;
      case RESET:
        hits = misses = score = 0;
        break;
      default:
        break;
    }

    this.props.setScore(hits, misses, score);

    if (!action) {
      return;
    }

    if (misses === 3) {
      this.onGameOver();
      return OVER;
    }

    Promise.resolve().then(this.saveGame);

    if (hits > 0 && hits % TASKS_PER_LEVEL === 0) {
      return CLEAR_LEVEL;
    }
  };

  resetTimer = time => {
    clearInterval(this.interval);
    this.interval = null;
    this.props.setTimeLeft(time);
  };

  renderShape = (ob, index, padding, opacity = 1, cursor = 'initial') => {
    const area = `1/${index + 1}`;
    const small = cursor === 'pointer';
    const style = {
      gridArea: area,
      opacity,
      padding,
      cursor,
      transform: this.state.transform,
      transition: ROTAION_TRANSITION,
    };

    return (
      <span
        key={index}
        style={style}
        onTouchStart={small ? () => this.handleTouch(index) : null}
        onMouseDown={small ? () => this.handleMouseDown(index) : null}>
        <Icon name={ob.shape} colors={ob.colors} />
      </span>
    );
  };

  handleStartOrContinue = () => {
    playSound(this.props, 'dice');
    this.updateScore(this.props.level > 1 ? CLEAR_LEVEL : RESET);
    this.props.showIntro(false);
    this.newSet();
  };

  handleCompete = () => {
    this.props.setMode(COMPETE);
    this.setState({ showScoreboard: true });

    if (this.props.level === 1 && !this.props.introduced) {
      this.props.setIntroduced(true);
      this.props.showIntro(true);
    }
  };

  handleGameOver = op => {
    if (op === SHOW_LEADERS) {
      this.props.showLeaderboards();
    } else if (op === OVER_RESTART) {
      this.restart();
    }
  };

  restart = () => {
    if (this.props.levelsCompleted > 0) {
      this.props.goToPage(SKILL_PAGE);
      return;
    }

    this.setState({ gameOver: false });
    this.props.setScore(0, 0, 0);
    this.props.setLevel(this.props.startLevel);
    this.newSet();
  };

  onGameOver = () => {
    this.props.requestResetStats(false);
    this.props.requestSurrender(false);

    f.onGameOver(this.props);
  };

  handleConfirmSurrender = yes => {
    if (yes) {
      this.props.pause(false);
      this.onGameOver();
      this.restart();
    }

    delay(() => this.props.requestSurrender(false));
  };

  handleConfirmResetStats = yes => {
    if (yes) {
      this.props.updateStats();
    }

    delay(() => this.props.requestResetStats(false));
  };

  handleResume = () => {
    this.props.pause(false);
  };

  handleCompetePrompt = op => {
    if (op === PRACTICE) {
      ++this.practiceHits;
      this.forceUpdate();
    } else {
      f.onCompete(this.props, this);
    }
  };

  render() {
    const gainOpacity = this.state.showGain ? 1 : 0;

    return (
      <div className="ms-page" style={{ grid: 'auto 1fr 56px/auto' }}>
        {this.props.mode === PRACTICE ? <Instructions step={this.props.practiceStep} /> : this.state.showScoreboard ? <Scoreboard /> : null}
        <div className="ms-board">
          {this.props.paused ? (
            <div className="ms-resume fadein-fast" onClick={this.handleResume}>
              {this.props.resetStats || this.props.surrender ? null : (
                <>
                  <span className="ms-game-paused">GAME PAUSED</span>
                  <ResumeIcon width="100px" style={{ gridArea: '1/1' }} />
                </>
              )}
            </div>
          ) : this.props.intro ? (
            <Intro onStart={this.handleStartOrContinue} />
          ) : (
            <>
              <div className="ms-big-shapes">
                {_.map(this.state.bigShapes, (s, i) => {
                  const padding = i ? '20px 30px 20px 15px' : '20px 15px 20px 30px';
                  return this.renderShape(s, i, padding);
                })}
              </div>
              <span className="ms-small-shapes">
                {_.map(this.state.smallShapes, (s, i) => {
                  const opacity = i === this.state.solutionIndex && this.hideSolution ? 0 : 1;
                  return this.renderShape(s, i, '5px', opacity, 'pointer');
                })}
              </span>
              <div className="ms-gain" style={{ opacity: gainOpacity }}>{`+${this.state.gain}`}</div>
            </>
          )}
          {this.props.surrender ? (
            <div className="ms-message-screen">
              <MessageBox message="Start over?" yesNo onReply={this.handleConfirmSurrender} />
            </div>
          ) : null}
          {this.props.resetStats ? (
            <div className="ms-message-screen">
              <MessageBox message="Reset stats?" yesNo onReply={this.handleConfirmResetStats} />
            </div>
          ) : null}
        </div>
        {this.props.mode === PRACTICE && this.practiceHits === 10 && (
          <div className="message ms-game-over-message fadein-fast">
            <span style={{ fontSize: '22px' }}>You are doing great!</span>
            {_.map([0, 1], i => {
              const margin = i ? 0 : '30px 0';
              const color = i ? YELLOW : GREEN;
              return (
                <div key={i} className="ms-game-over-option" style={{ margin }} onClick={() => this.handleCompetePrompt(i ? COMPETE : PRACTICE)}>
                  {i ? <CompeteIcon width="36" style={{ gridArea: '1/1' }} /> : <PracticeIcon width="36px" style={{ gridArea: '1/1' }} />}
                  <span style={{ gridArea: '1/1', marginLeft: '50px', color }}>{i ? 'Compete' : 'Continue practicing'}</span>
                </div>
              );
            })}
          </div>
        )}
        {this.state.gameOver && !this.props.resetStats && <GameOverOptions header="Game Over" handleResponse={this.handleGameOver} />}
      </div>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  {
    setMode,
    setPracticeStep,
    setTimeLeft,
    setScore,
    setStartLevel,
    setLevel,
    setLevelsCompleted,
    setIntroduced,
    updateStats,
    requestSurrender,
    requestResetStats,
    showLeaderboards,
    pause,
    setLoadingGame,
    showIntro,
    goToPage,
  },
  null,
  { forwardRef: true }
)(Board);
